import * as React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/organisms/layout'
import Seo from '../components/molecules/seo'
import Posts from '../components/molecules/posts'
import Pagination from '../components/molecules/pagination'

const Index = props => {
  const siteTitle = props.data.site.siteMetadata?.title || `Title`
  const seoTitle = 'パイズリ挟射好きにオススメのエロ動画を紹介!!'
  const posts = props.data.posts.edges

  return (
    <Layout location={props.location} title={siteTitle} >
      <Seo title={seoTitle} />
      <Posts posts={posts} />
      <Pagination props={props} />
    </Layout>
  )
}

export default Index

export const pageQuery = graphql`
  query ($skip: Int!) {
    site {
      siteMetadata {
        title
      }
    }

    posts:allMarkdownRemark( 
      sort: {frontmatter: {date: DESC}}
      skip: $skip
      limit: 18
      filter:{ frontmatter:{ tags:{ nin:["配信予定"] } } }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "YYYY-MM-DD")
            update(formatString: "YYYY-MM-DD")
            title
            actress
            tags
            ptags
            pcount
            fcount
            recommend
            name
            thumbnail {
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  placeholder: BLURRED
                  formats: [AUTO, WEBP, AVIF]
                )
              }
            }
            release(formatString: "YYYY-MM-DD")
          }
        }
      }
    }
  }
`